import { render } from "./LSJDictionaryEntryWidget.vue?vue&type=template&id=8b7a3ee8&scoped=true"
import script from "./LSJDictionaryEntryWidget.vue?vue&type=script&lang=js"
export * from "./LSJDictionaryEntryWidget.vue?vue&type=script&lang=js"

import "./LSJDictionaryEntryWidget.vue?vue&type=style&index=0&id=8b7a3ee8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7a3ee8"]])

export default __exports__